
  import Vue from "vue";
  import ModalDialog from "@/components/ModalDialog.vue";
  import EmployeeService, {WagePeriodV3Dto} from "@/service/EmployeeService";

  export default Vue.extend({
    name: "EmployeeDetailsCardWagesHistory",
    components: {
      ModalDialog
    },
    props: {
      employeeUuid: {
        type: String,
        default: null
      }
    },
    data: () => ({
      dialog: false,
      wages: new Array<WagePeriodV3Dto>()
    }),
    watch: {
      dialog (open: boolean) {
        if (open) {
          this.load();
        }
      }
    },
    methods: {
      // Loads the wages on every opening, so the history also shows wages changed since the last one
      load () {
        if (this.employeeUuid) {
          EmployeeService.getEmployeeWagesV3(this.employeeUuid)
            .then(wages => {
              this.wages = wages;
            });
        }
      }
    }
  });
